import { Icon, Markdown } from '@carrent/ui'
import { kbApi } from '@carrent/api'

/**
 * Статья: крошки, заголовок, тело, вложения.
 *
 * Картинки в тексте пишутся как `![схема](attachment:12)` и ходят
 * на сервер через /api/kb/attachments/12 — там проверяются права
 * пространства, как и у самой статьи.
 */
const resolveImage = (href) => {
  const m = String(href || '').match(/^attachment:(\d+)$/)
  if (m) return kbApi.attachmentUrl(m[1])
  return /^(https?:|\/)/i.test(href) ? href : null
}

export function ArticleView({ page, breadcrumbs, onNavigate }) {
  const attachments = page.attachments || []

  return (
    <article className="kb-article">
      {breadcrumbs.length > 1 && (
        <nav className="kb-article__crumbs" aria-label="Путь к статье">
          {breadcrumbs.map((c, i) => (
            <span key={c.id} className="kb-article__crumb">
              {i > 0 && <Icon name="chevronRight" size={12} aria-hidden="true" />}
              {i === breadcrumbs.length - 1 ? (
                <span aria-current="page">{c.title}</span>
              ) : (
                <button type="button" onClick={() => onNavigate(c)}>{c.title}</button>
              )}
            </span>
          ))}
        </nav>
      )}

      <header className="kb-article__head">
        <h1 className="kb-article__title">{page.title}</h1>
        <div className="kb-article__meta">
          {page.status === 'draft' && (
            <span className="badge badge--draft">Черновик</span>
          )}
          {page.revision_number != null && (
            <span className="kb-article__version">Версия {page.revision_number}</span>
          )}
          {(page.labels || []).map((l) => (
            <span key={l} className="kb-article__label">{l}</span>
          ))}
        </div>
      </header>

      <Markdown text={page.body_md} resolveImage={resolveImage} className="kb-article__body" />

      {attachments.length > 0 && (
        <section className="kb-article__files">
          <h2 className="kb-article__files-title">Вложения</h2>
          <ul>
            {attachments.map((a) => (
              <li key={a.id}>
                <a href={kbApi.attachmentUrl(a.id)} target="_blank" rel="noopener noreferrer">
                  <Icon name="file" size={16} aria-hidden="true" />
                  {a.filename}
                </a>
              </li>
            ))}
          </ul>
        </section>
      )}
    </article>
  )
}
